import EzUtils from "../../utils/EzUtils";
import storageUtil from "../../utils/StorageUtil";

const PREF_MANAGER_DATA = "prefManagerData";

export default {

  clearPrefs() {
    storageUtil.removeItem(PREF_MANAGER_DATA);
  },

  setPrefs(prefManagerData) {
    storageUtil.setItem(PREF_MANAGER_DATA, JSON.stringify(prefManagerData));
  },

  getPrefs() {
    let prefManagerData = EzUtils.convertToJSONObjectIfString(
      storageUtil.getItem(PREF_MANAGER_DATA)
    );
    return prefManagerData ? prefManagerData : {};
  },

  setUser(user) {
    let prefManagerData = this.getPrefs();
    prefManagerData.user = user;
    this.setPrefs(prefManagerData);
  },

  getUser() {
    let prefManagerData = this.getPrefs();
    return prefManagerData.user;
  },

  setOauthData(oauthData) {
    let prefManagerData = this.getPrefs();
    prefManagerData.oauthData = oauthData;
    this.setPrefs(prefManagerData);
  },

  getOauthData() {
    let prefManagerData = this.getPrefs();
    return prefManagerData.oauthData;
  },

  getOauthRefreshToken() {
    const oauthData = this.getOauthData();
    return oauthData ? oauthData["refresh_token"] : "";
  },

  getOauthAccessToken() {
    const oauthData = this.getOauthData();
    return oauthData ? oauthData["access_token"] : "";
  },

  getUserId() {
    let userId = -1;
    let userDetails = this.getUser();
    if (userDetails != null) {
      if (EzUtils.isValidId(userDetails.userId)) {
        userId = userDetails.userId;
      } else if (EzUtils.isValidId(userDetails.id)) {
        userId = userDetails.id;
      }
    }
    return userId;
  },

  getStaffId() {
    const userDetails = this.getUser();
    return userDetails ? userDetails.staffId : -1;
  },

  setUserOfficeName(officeName) {
    const userDetails = this.getUser();
    userDetails.officeName = officeName;
    this.setUser(userDetails);
  },


  setUserOfficeId(officeId) {
    const userDetails = this.getUser();
    userDetails.officeId = officeId;
    this.setUser(userDetails);
  },

  getUserOfficeId() {
    const userDetails = this.getUser();
    return userDetails && EzUtils.isValidId(userDetails.officeId) ? userDetails.officeId : -1
  },

  getUserMobile() {
    let mobile = "";
    let userDetails = this.getUser();
    if (userDetails != null) {
      if (EzUtils.isNotEmpty(userDetails.mobile)) {
        mobile = userDetails.mobile;
      }
    }
    return mobile;
  },

  clearUser() {
    let prefManagerData = this.getPrefs();
    prefManagerData.user = {};
    this.setPrefs(prefManagerData);
  },

  setStaffDetails(staffDetails) {
    let prefManagerData = this.getPrefs();
    prefManagerData.staffDetails = staffDetails;
    this.setPrefs(prefManagerData);
  },

  getStaffDetails() {
    let prefManagerData = this.getPrefs();
    return prefManagerData.staffDetails;
  },

  clearStaffDetails() {
    let prefManagerData = this.getPrefs();
    prefManagerData.staffDetails = {};
    this.setPrefs(prefManagerData);
  },

  setStaffConfig(staffConfig) {
    let prefManagerData = this.getPrefs();
    prefManagerData.staffConfig = staffConfig;
    this.setPrefs(prefManagerData);
  },

  getStaffConfig() {
    let prefManagerData = this.getPrefs();
    return prefManagerData.staffConfig;
  },

  clearStaffConfig() {
    let prefManagerData = this.getPrefs();
    prefManagerData.staffConfig = {};
    this.setPrefs(prefManagerData);
  },

  getRetailerConfig() {
    const prefManagerData = this.getPrefs();
    return prefManagerData.retailerConfig;
  },

  setRetailerConfig(retailerConfig) {
    const prefManagerData = this.getPrefs();
    prefManagerData.retailerConfig = retailerConfig;
    this.setPrefs(prefManagerData);
  },

  isMultipleOfficePresent() {
    const prefManagerData = this.getPrefs();
    return prefManagerData.multipleOfficePresent;
  },

  setMultipleOfficePresent(multipleOfficePresent) {
    const prefManagerData = this.getPrefs();
    prefManagerData.multipleOfficePresent = multipleOfficePresent;
    this.setPrefs(prefManagerData);
  },

  doesUserHasRole(roleToCheck) {
    const user = this.getUser();
    if (!roleToCheck || !user || (!user.roles && !user.selectedRoles)) {
      return false
    }
    const roles = user.roles || user.selectedRoles;
    let hasRole = false;
    roles && roles.forEach(role => {
      if (role.name === roleToCheck) {
        hasRole = true;
      }
    })

    return hasRole;
  },

  isUsePriceForLoanAmount() {
    const retailerConfig = this.getRetailerConfig();
    return retailerConfig && retailerConfig.usePriceForLoanAmount 
      ? retailerConfig.usePriceForLoanAmount : false;
  },

  showEmiTenure(){
    const retailerConfig = this.getRetailerConfig();
    return retailerConfig && 
    (typeof retailerConfig.showEmiTenure == undefined 
        || retailerConfig.showEmiTenure == null || retailerConfig.showEmiTenure)
      ? true : false;
  },

  showLoanPrice(){
    const retailerConfig = this.getRetailerConfig();
    return retailerConfig && 
    (typeof retailerConfig.showLoanPrice == undefined 
          ||retailerConfig.showLoanPrice == null || retailerConfig.showLoanPrice)
      ? true : false;
  },

  showBrandAndModel(){
    const retailerConfig = this.getRetailerConfig();
    return retailerConfig && 
    (typeof retailerConfig.showBrandAndModel == undefined 
      || retailerConfig.showBrandAndModel == null || retailerConfig.showBrandAndModel)
      ? true : false;
  }

};

